// extracted by mini-css-extract-plugin
export var topSection = "jobPost-module--top-section--383v5";
export var heading = "jobPost-module--heading--1ZMGX";
export var copy = "jobPost-module--copy--1YwMk";
export var headingImage = "jobPost-module--heading-image--2uA8O";
export var legal = "jobPost-module--legal--32U6b";
export var spacer = "jobPost-module--spacer--3owWr";
export var tabletButton = "jobPost-module--tablet-button--2P69N";
export var mobileButton = "jobPost-module--mobile-button--3BIvH";
export var formBlocked = "jobPost-module--form-blocked--2J9DX";
export var copyWrap = "jobPost-module--copy-wrap--3ZosG";
export var purple = "jobPost-module--purple--Thaov";
export var headingCopy = "jobPost-module--heading-copy--31y3z";
export var applyButton = "jobPost-module--apply-button--2PLKM";
export var formWrap = "jobPost-module--form-wrap--3cnVS";